import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DisplayOptions } from '@store/user/user.model';
import { ModalType } from '@shared/models/modal.model';
import { Observable } from 'rxjs';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { EulaModalComponent } from '@shared/components/eula-modal/eula-modal.component';

@Injectable({
  providedIn: 'root'
})
export class EulaService {
  constructor(private readonly http: HttpClient,
              private readonly dialog: MatDialog) { }

  public getEulaText(eulaFilename: string) {
    return this.http.post('/api/get-eula-text', {eulaFilename}, {responseType: 'text'});
  }

  public updateEulaStatus(status: DisplayOptions): Observable<void> {
    const params = new HttpParams().set('eulaStatus', status);
    return this.http.put<void>('/api/update-eula-status', null, {params});
  }

  public openEulaModal(agreement: string): Observable<boolean> {
    return this.dialog.open(EulaModalComponent, {
      backdropClass: 'eula-modal-backdrop',
      panelClass: ModalType.SMALL,
      data: agreement
    } as MatDialogConfig).afterClosed();
  }
}
